import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";

/**
 * RSA加密
 * @param value 原始值
 */
export function rsaEncrypt(value: string) {
  const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzGBq2T8dVERN+gPmSsLEUVOjH
ix5JOw7562ccfEWopJk8O1r0+yK9IAoGUM2NWcC3JDSNkCUYU3mjsvZwluzPKylp
CACjBgZ4o4a1xj+AZi0Ctxlo0SqYbXjH8zA4ej3NmyJcmtBCrhetpA5IqjWB2u1k
ZBP3pQeYH8sIuCiOEwIDAQAB
-----END PUBLIC KEY-----`;

  try {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt(value) || "";
  } catch (error) {
    throw error;
  }
}

/**
 * RSA加密
 * @param value 原始值
 */
export function rsaDecrypt(value: string) {
  const publicKey = `-----BEGIN RSA PRIVATE KEY-----
  MIICXQIBAAKBgQDUa6hEl3NKVmOO10gHXEML/tYrkgqbZD5N1NF33nJeG1ihTjtK
  mN4gKelHnYM9W/jCdOXnlYIIGY1nkJt+9/S4RHdTvWbJh6lsrGc16UfQmtEwgUoz
  1nZUXauMSZi/ffNdiwgmHuR/javcPVtaTQJvy36oTSiQCo3X81ENKgbltQIDAQAB
  AoGBAKGrWkLyHZ4LR/SUJs7rSmAb0TcSDJ6d2cl02wPnOpYjK/6AwyGQXSaPn2uR
  FyyhDiA5xizOnku53uReq+ojn40n7LJCLJq6TFV/I4mQMkpFWZIJ9m4AemVD3Hap
  qHR4ihNpf8hqbEaDX4c2Fm8w/uXtAWGrmTHKAxnp5loRgbHVAkEA8SI8jfAfoDM/
  /z824hRnAa9SZiaKoWURIhzSG9QX9BbBhbK7LFNnpHAfjascQAuxfE5fLMknqL57
  z47KvO/B4wJBAOGEPw4BiDcnA1ukmPYHTARJrDNkiPID9KDY5KdxHla0QORKRpVR
  QbYX/Jt/06szdyi5hJneN7SDrsl7utvubYcCQFaLtTQ0dQVon5WbOLWYIQhnxqlH
  OAaJYcbelULLsvU2narA5ZEZNl+8pnaQbYlHKSK2dk56vDNCeumaFIYPf4UCQQDc
  1xawbouoBsphChTIiWjFoifBxCffaEQ852kzF7EwEyCg7qOkQYhp+59h35G2y5Vb
  CiFyVIyUd4fIwyO/kAMtAkBjpeUIZvE7vFVCR1AEqaUA4OM19jBJnAWLz/Qk5/77
  4y5r1SpebpKokKemc7rqTMOgjR3vR6ufxGWSp0/bELRP
  -----END RSA PRIVATE KEY-----`;

  try {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    return encrypt.decrypt(value) || "";
  } catch (error) {
    throw error;
  }
}

/**
 * DES加密
 * @param value 原始值
 */
export function desEncrypt(value: string) {
  return CryptoJS.DES.encrypt(value, CryptoJS.enc.Utf8.parse("eastabcd"), {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse("eastabcd"),
  }).toString();
}

/**
 * DES解密密
 * @param value 原始值
 */
export function desDecrypt(value: string) {
  return CryptoJS.DES.decrypt(value, CryptoJS.enc.Utf8.parse("eastabcd"), {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse("eastabcd"),
  }).toString(CryptoJS.enc.Utf8);
}
